import axios from 'axios';
import qs from 'qs';
import constant from '../constant/constant';
import apiService from "../common/commonApi";
import CONSTANT from '../constant/constant';

export const commonService = {};

commonService.getKey = async (url) => {    
    return apiService.Get(url);
}

commonService.exportFile = async (url, param) => {    
    return commonService.GetFile(url, param);
}

commonService.GetFile = (url, _params) => {
    const _body = qs.stringify(_params);
    window.open(constant.apiUrl + url + '?' + _body);
}

commonService.importFile = async (url, param) => {  
    return commonService.UploadFile(url, param);
}

commonService.UploadFile = (url, _params) => {
    const _url = constant.apiUrl + url;
    const formData = new FormData();
    formData.append('file',_params['file'])
    formData.append('secretKey',_params['secretKey'])
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    return axios.post(_url, formData,config)
        .then(res => {
            if (res.data.http_code === CONSTANT.errorCode.APIDuplicate) {
                const error = res.data.result;
                localStorage.setItem('msgError', JSON.stringify(error));
                window.location = '/error/404';      
            } else if (res.data.http_code === CONSTANT.errorCode.APISuccess) {
                return window.location = res.data.result.url;
            }
        })
        .catch((error) => {
            errorHandle(error);
        });
}

commonService.importErOmFile = async (url, param) => {  
    return commonService.UploadErOmFile(url, param);
}

commonService.UploadErOmFile = (url, _params) => {
    const _url = constant.apiUrl + url;
    const formData = new FormData();
    formData.append('file',_params['file'])
    formData.append('secretKey',_params['secretKey'])
    formData.append('month',_params['month'])
    formData.append('year',_params['year'])
    formData.append('superviorId',_params['superviorId'])
    formData.append('approverId',_params['approverId'])
    formData.append('currentUrl',_params['currentUrl'])
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    return axios.post(_url, formData,config)
        .then(res => {
            if (res.data.http_code === CONSTANT.errorCode.APIDuplicate) {
                const error =  res.data.result;
                localStorage.setItem('msgError',JSON.stringify(error));
                window.location = '/error/404';      
            } else if (res.data.http_code === CONSTANT.errorCode.APISuccess) {
                return window.location = res.data.result.url;
            }
        })
        .catch((error) => {
            errorHandle(error);
        });
}

const errorHandle = (error) => {
    if (localStorage.RequestApiTime !== undefined) {        
        if (error.code === 'ECONNABORTED') {
            window.location = '/error/500';
        } else {
            window.location = '/error/404';
        }
    }
}

commonService.PostKey = async (url, _params) => { 
    return apiService.Post(url, _params);
} 
